import React from 'react'
import styled from 'styled-components'

import Panel from 'components/Panel'
import { Caption, Button } from '@sketch/components'

import { useModalContext } from 'containers/ModalManager'

import { ChooseSsoWorkspaceShortNameModal } from '../../modals/ChooseSsoWorkspaceShortNameModal'

const PanelHeader = styled(Panel.Header)`
  padding: 0;
`

const PanelBody = styled(Panel.Body)`
  /** We need to override Panel.Body padding in this case*/
  && {
    padding: 0;
  }
`

interface WorkspaceSettingsEnableSsoPanelProps {
  customerId: string
}

export const WorkspaceSettingsEnableSsoPanel: React.FC<WorkspaceSettingsEnableSsoPanelProps> = props => {
  const { customerId } = props
  const { showModal } = useModalContext()

  const onChooseShortNameSelected = () => {
    showModal(ChooseSsoWorkspaceShortNameModal, { customerId })
  }

  return (
    <Panel>
      <PanelHeader>Set Up Single Sign-On (SSO)</PanelHeader>
      <PanelBody>
        <Caption>
          Begin by choosing the SSO shortname that people in your Workspace will
          use to sign in
        </Caption>
        <Button variant="primary" onClick={onChooseShortNameSelected} size="32">
          Choose a Shortname
        </Button>
      </PanelBody>
    </Panel>
  )
}
